import Link from "next/link";

/**
 * Round 3 header. Mobile-first chrome, single visible action.
 *
 * The header competes with the homepage CTA for attention. Round 3 resolves
 * that by hiding the "Take the test" link until ≥sm — on mobile we let the
 * primary CTA inside the hero own the screen.
 */
export function SiteHeader() {
  return (
    <header className="sticky top-0 z-30 border-b border-hairline bg-canvas/85 backdrop-blur supports-[backdrop-filter]:bg-canvas/70">
      <div className="mx-auto flex h-14 max-w-page items-center justify-between px-page-x sm:px-page-x-md lg:px-page-x-lg">
        <Link
          href="/"
          className="font-display text-[17px] font-bold tracking-tight text-ink"
          aria-label="Moneyimprint — home"
        >
          moneyimprint
          <span className="ml-0.5 text-teal-deep">.</span>
        </Link>
        <nav className="flex items-center gap-5">
          <Link
            href="/money-personality"
            className="text-caption font-semibold text-ink hover:text-teal"
          >
            Money types
          </Link>
          <Link
            href="/blog"
            className="text-caption font-semibold text-ink hover:text-teal"
          >
            Blog
          </Link>
          <Link
            href="/spending-personality-test"
            className="hidden text-caption font-semibold text-ink hover:text-teal sm:inline-block"
          >
            Take the test →
          </Link>
        </nav>
      </div>
    </header>
  );
}
